/** 0-based page indexes to prefetch around the current server page. */
export function adjacentListPages(
  page: number,
  pageSize: number,
  totalCount: number,
): number[] {
  if (pageSize <= 0 || totalCount <= 0 || page < 0) return [];
  const lastPage = Math.max(0, Math.ceil(totalCount / pageSize) - 1);
  const pages: number[] = [];
  if (page > 0) pages.push(page - 1);
  if (page < lastPage) pages.push(page + 1);
  return pages;
}
